/* Keep the calm header in sync with Horizon's native cart quantity/removal events. */
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  if (!event.promise || typeof event.promise.then !== 'function') return;
  try {
    const { cart, detail } = await event.promise;
    const count = Number(cart?.totalQuantity ?? detail?.itemCount);
    if (!Number.isFinite(count) || count < 0) return;
    document.querySelectorAll('.gbm-basket').forEach((link) => {
      let badge = link.querySelector('.gbm-cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'gbm-cart-count';
        link.append(badge);
      }
      if (badge) {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      }
      link.setAttribute('aria-label', count ? `Basket, ${count} ${count === 1 ? 'item' : 'items'}` : 'Basket');
    });
  } catch {
    // The native cart displays mutation errors; keep the last confirmed count.
  }
});
